// extracted by mini-css-extract-plugin
export default {"RulesBaseComponent":"RulesBaseComponent_RulesBaseComponent__q9E-f"};